<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EMZTuc/tc-custom/9781488014635.jpg?1728155802945" alt="This image is the cover for the book Christmastime Courtship, Matchmaking Mamas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmastime Courtship, Matchmaking Mamas
      </h1>
      <p class="bookDescription body article font2">
        <b>Stop…in the name of love</b><br/><br/>What kind of motorcycle cop gives a speeding ticket around <i>Christmas</i>? One as by the book as Colin Kirby. But when he stops pediatric oncology nurse Miranda Steele, little does he know that she’s about to zoom straight into his heart. Or that the Matchmaking Mamas have the unlucky-in-love pair straight in their sights…<br/><br/>After a childhood tragedy, bright-as-sunshine Miranda’s used to making the best of any situation. So she knows the handsome policeman represents an opportunity: he needs to visit her sick kids at the hospital. But Miranda quickly realizes the closed-off Colin is in need of her help just as much as any of those she volunteers for. And she’s determined to work her way into his heart this holiday season.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?151a78ce